import { navItems } from "@/mocks/content";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-semibold text-lg text-foreground-950">
                年轻的母亲在线
              </span>
            </div>
            <p className="mt-4 text-sm leading-7 text-foreground-600 max-w-md">
              一个围绕年轻母亲题材短剧与剧情片的单页索引站。我们把题材条目、剧情看点、观看方式说明与常见问题整理在一起，
              方便你一次性了解「完整版、短剧、看全集、未删减、剧情」这些关注点的差别。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["题材索引", "剧情看点", "观看指南"].map((t) => (
                <span
                  key={t}
                  className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-foreground-950 text-base">页面分区</h3>
            <ul className="mt-4 space-y-2.5">
              {navItems.slice(0, 6).map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-foreground-950 text-base">浏览提示</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-secondary-600 mt-0.5" aria-hidden="true"></i>
                按题材标签筛选选片
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-secondary-600 mt-0.5" aria-hidden="true"></i>
                剧情看点可逐条展开
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-secondary-600 mt-0.5" aria-hidden="true"></i>
                观看方式在下单前先确认
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {year} 年轻的母亲在线 · 本站为题材内容索引与说明页面
          </p>
          <p className="text-xs text-foreground-500">
            排行与评分均为编辑整理的示意数据，具体内容请以你观看的平台为准
          </p>
        </div>
      </div>
    </footer>
  );
}